import { useContext, useEffect, useRef, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import { IdcardOutlined } from "@ant-design/icons";
import { Typography, Form, Space, Input, Button } from "antd";
import axios from "axios";
import { LockOutlined } from "@ant-design/icons";

const RFIDTeamLeaderValidation = ({ setVoidValidate }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const formRef = useRef(null);
  const [focused, setFocused] = useState(false);
  const [cardUIDValue, setCardUIDValue] = useState("");
  const { rerunNotif } = useContext(NotificationInfo);
  const [username, setUsername] = useState(null);
  const [loadings, setLoadings] = useState(false);

  const onFocus = () => setFocused(true);

  const onBlur = (e) => {
    setFocused(false);
    if (!e.relatedTarget) {
      e.target.focus();
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    axios
      .post("user/merchant/validate/rfid-team-leader", {
        rfid: cardUIDValue,
      })
      .then((response) => {
        if (focused) {
          const data = response.data;
          if (data.result === "success") {
            // close();
            // closeOriginDrawer();
            setUsername(data.username);
            // setVoidValidate(true);
            rerunNotif("success", "validated successfully.");
          } else {
            // setVoidValidate(false);
            rerunNotif(
              "error",
              "Presented RFID is not assigned to Team Leader."
            );
          }
        }
        setIsSubmitting(false);
        setCardUIDValue("");
        setFocused(true);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  };

  useEffect(() => {
    setFocused(true);
  }, []);

  const handleConfirm = (values) => {
    const formdata = new FormData();

    formdata.append("username", username);

    for (const name in values) {
      formdata.append(name, values[name]);
    }
    setLoadings(true);
    axios
      .post("user/merchant/validate/team-leader-account", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "You are now able to void product.");
          setVoidValidate(true);
        }
        if (data === "invalid") {
          rerunNotif("error", "Invalid credential.");
        }
        setLoadings(false);
      })
      .catch((error) => {
        console.log("ERROR: ", error);
        setLoadings(false);
      });
  };

  return (
    <div>
      {username === null && (
        <>
          <form
            onSubmit={handleSubmit}
            ref={formRef}
            style={{
              border: "1px solid red",
              opacity: 0,
            }}
          >
            <div style={{ display: "flex", flexDirection: "row" }}>
              <input
                type="text"
                autoFocus
                name="card_uid"
                id="card_uid"
                onFocus={onFocus}
                onBlur={onBlur}
                onChange={(e) => setCardUIDValue(e.target.value)}
                value={cardUIDValue}
                autoComplete="off"
              />
              <button type="submit" disabled={isSubmitting}>
                SUBMIT
              </button>
            </div>
          </form>
          <div style={{ borderRadius: 20, marginBottom: 20 }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <IdcardOutlined style={{ fontSize: "200px" }} />
              <Typography
                style={{
                  fontWeight: "bold",
                  color: "red",
                  fontStyle: "italic",
                }}
              >
                Please scan the RFID
              </Typography>
              <Typography style={{ fontSize: 18, fontWeight: "bold" }}>
                Scanning...
              </Typography>
            </div>
          </div>
          <div />
        </>
      )}

      {username !== null && (
        <>
          <div
            style={{
              // border: "1px solid red",
              marginTop: 40,
            }}
          >
            <Form
              name="login"
              //   initialValues={{ remember: true }}
              onFinish={handleConfirm}
              autoComplete="off"
            >
              <Space
                direction="vertical"
                style={{
                  //   paddingLeft: 10,
                  //   paddingRight: 10,
                  width: "100%",
                  //   border: "1px solid red",
                }}
              >
                {/* <Form.Item
                style={{ marginBottom: "5px", marginTop: "5px" }}
                name="username"
                rules={[{ required: true, message: "Username is required!" }]}
              >
                <Input
                  prefix={<UserOutlined />}
                  placeholder="Your username"
                  size="large"
                />
              </Form.Item> */}
                <Form.Item
                  //   style={{ marginBottom: "5px" }}
                  name="password"
                  rules={[{ required: true, message: "Password is required!" }]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    placeholder="Your password"
                    size="large"
                  />
                </Form.Item>

                <Form.Item
                // style={{ marginTop: "5px" }}
                >
                  <Button
                    type="primary"
                    loading={loadings}
                    htmlType="submit"
                    style={{
                      width: "100%",
                      // background: "#fff",
                      // color: "#000",
                      borderRadius: "20px",
                    }}
                  >
                    {loadings ? "Verifying..." : "Confirm"}
                  </Button>
                </Form.Item>
              </Space>
            </Form>
          </div>
        </>
      )}
    </div>
  );
};

export default RFIDTeamLeaderValidation;
